import * as api from 'api/DisclaimersApi';

export const UPDATE_DISCLAIMERS = 'disclaimers/actions/UPDATE';

export const initialState = {
  estimateTooltip: '',
};

/**
 * Simple thunk for retrieving the disclaimers and updating the state
 * @returns {{payload: any, type: string}}
 */
export function updateDisclaimers() {
  return async (dispatch) => {
    const res = await api.getDisclaimers();
    const action = {
      type: UPDATE_DISCLAIMERS,
      payload: {
        estimateTooltip: res.estimatedValueHowToRead_anz,
      },
    };

    return dispatch(action);
  };
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_DISCLAIMERS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
